module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loadwrap"
  }, [_c('p', {
    staticClass: "loading"
  }, [_c('span', {
    staticClass: "loadingicon",
    class: {
      'loadingiconStats': _vm.statsLoading
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "loadingtext",
    attrs: {
      "id": "loadingWord"
    }
  }, [_vm._v("memuat lebih banyak")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c51ace98","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading.vue
// module id = 544
// module chunks = 2 3 5 6